/* EDELHOLZ Mess-Beacon Berater + Endbild (14.10.2026).
   Schickt Interaktionen mit dem Berater (/pages/berater) und dem Endbild "So steht er bei dir" (PDP + Konfigurator)
   als eigenen Beacon an /api/track, gleiches Grundschema wie die LP-Events (snippets/edelholz-lp-tracking.liquid):
   sid, vid, pv, path, mob, utm-/Klick-ID-Felder, src, intern. Nur nach Einwilligung (Marketing oder Analytics),
   vorher wird gesammelt und nach der Zustimmung nachgesendet. Serverseite: edelholz-dashboard PR #49.

   Ereignisse (CustomEvent 'eh:track' auf window, detail {name, data}):
   - berater_seite|berater_start|berater_frage|berater_ergebnis|berater_mail|berater_konfig_klick (assets/edelholz-berater.js)
     -> event EH_LP_Berater, aktion seite|start|frage|ergebnis|mail|konfig, quelle (?von=), step 0-7, modell, news
   - endbild (assets/edelholz-konfig-raumbild.js) -> event EH_LP_Endbild, position pdp|konfigurator,
     aktion ansicht|holz|boden|wand|pflanze|blende|vollbild, section (gewaehlter Wert)
   Je Seitenaufruf und Schluessel (aktion+step bzw. aktion+section) genau einmal. Keine Namen, keine Mailadressen.
   Hinweis: der Berater hat 7 Fragen (step 0-6), 7 = Ergebnis. */
(function () {
  'use strict';
  if (window.__ehMessBeaconInit) return; window.__ehMessBeaconInit = true;

  var ENDPOINT = 'https://dashboard.edelholz-manufaktur.de/api/track';
  var PV = 'p' + Math.random().toString(36).slice(2, 10);
  var fired = {};
  var AKTION = { berater_seite: 'seite', berater_start: 'start', berater_frage: 'frage', berater_ergebnis: 'ergebnis', berater_mail: 'mail', berater_konfig_klick: 'konfig', berater_ar: 'ar', berater_deko: 'deko', berater_blende: 'blende' }; /* ar (15.10.): 'Stell ihn in deinen Raum' getippt; deko/blende (15.10., Ads-Pipeline): Schalter im Ergebnis, section an|aus */
  var ENDBILD_AKTION = ['ansicht', 'holz', 'boden', 'wand', 'pflanze', 'blende', 'vollbild'];

  function attr() { try { return (window.EdelholzAttribution && window.EdelholzAttribution.get()) || {}; } catch (e) { return {}; } }
  function istIntern() { try { return localStorage.getItem('eh_intern') === '1'; } catch (e) { return false; } }
  /* Werte wie der Server sie erwartet: nur a-z, 0-9, _ ; Kleinbuchstabe vorn. Leer = weglassen. */
  function sauber(v, max) {
    var s = String(v == null ? '' : v).toLowerCase().replace(/[\s-]+/g, '_').replace(/[^a-z0-9_]/g, '').replace(/^[^a-z]+/, '');
    return s.slice(0, max || 30); /* Server: ^[a-z][a-z0-9_]{0,29}$ */
  }

  /* ---- Consent (wie edelholz-lp-tracking: Shopify Customer-Privacy-API, Live-Update per visitorConsentCollected) ---- */
  var consentGiven = false, pending = [], tries = 0;
  function hasConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
      var c = cp.currentVisitorConsent();
      return !!(c && (c.marketing === 'yes' || c.analytics === 'yes'));
    } catch (e) { return false; }
  }
  function onConsentReady() {
    if (consentGiven) return;
    consentGiven = true;
    while (pending.length) { var p = pending.shift(); try { beacon(p); } catch (e) {} }
  }
  function waitForConsent() {
    if (hasConsent()) { onConsentReady(); return; }
    if (++tries < 200) setTimeout(waitForConsent, 300); /* ~60 s */
  }
  document.addEventListener('visitorConsentCollected', function () { if (hasConsent()) onConsentReady(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForConsent); else waitForConsent();

  function beacon(params) {
    try {
      var a = attr();
      var p = {
        sid: a.sid || '', vid: a.vid || '', pv: PV, path: location.pathname,
        mob: window.matchMedia('(max-width: 749px)').matches ? 1 : 0,
        utm_source: a.utm_source || '', utm_campaign: a.utm_campaign || '', utm_content: a.utm_content || '',
        gclid: a.gclid || '', gbraid: a.gbraid || '', wbraid: a.wbraid || '',
        campaign_id: a.campaign_id || '', ad_id: a.ad_id || '',
        src: (a.gclid || a.gbraid || a.wbraid || a.campaign_id) ? 'google' : ((a.fbclid || a.fbc) ? 'meta' : 'utm')
      };
      if (istIntern()) p.intern = 1;
      for (var k in params) { if (params.hasOwnProperty(k)) p[k] = params[k]; }
      navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(p)], { type: 'text/plain' }));
    } catch (e) {}
  }
  function fire(key, params) {
    if (fired[key]) return;
    fired[key] = true;
    if (!consentGiven) { pending.push(params); return; }
    beacon(params);
  }

  function berater(name, d) {
    var aktion = AKTION[name]; if (!aktion) return;
    var step = 0;
    if (aktion === 'frage' || aktion === 'start') step = parseInt(d.step, 10) || 0;
    else if (aktion !== 'seite') step = 7;
    if (step < 0 || step > 7) return;
    var p = { event: 'EH_LP_Berater', aktion: aktion, step: step };
    var q = sauber(d.quelle, 30); p.quelle = q || 'direkt';
    var m = sauber(d.modell, 30); if (m && aktion !== 'seite' && aktion !== 'start' && aktion !== 'frage') p.modell = m;
    if (aktion === 'mail') p.news = d.news ? 1 : 0;
    var sec = '';
    if (aktion === 'deko') sec = d.deko === 'pur' ? 'aus' : 'an';
    if (aktion === 'blende') sec = d.blende === 'saphir' ? 'an' : 'aus';
    if (sec) p.section = sec;
    fire('berater_' + aktion + '_' + step + '_' + sec, p);
  }
  function endbild(d) {
    var pos = d.position === 'pdp' ? 'pdp' : (d.position === 'konfigurator' ? 'konfigurator' : '');
    var aktion = String(d.aktion || '');
    if (!pos || ENDBILD_AKTION.indexOf(aktion) < 0) return;
    var p = { event: 'EH_LP_Endbild', position: pos, aktion: aktion };
    var s = sauber(d.section, 30); if (s) p.section = s;
    fire('endbild_' + pos + '_' + aktion + '_' + (s || ''), p);
  }

  window.addEventListener('eh:track', function (e) {
    try {
      var det = e.detail || {}, name = String(det.name || ''), d = det.data || {};
      if (name === 'endbild') endbild(d);
      else if (AKTION[name]) berater(name, d);
    } catch (x) {}
  });
})();
